import Swal from "sweetalert2";
import api from "../../../utilities/interseptor";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API
export const getEstructuras = async (setEstructuras, id_cliente, anio) => {
    const data = {
        id_cliente: id_cliente,
        anio: anio
    }
    await api.post(apiUrl + `/monitor/programacion/get-estructuras`, data).then((res) => {
        setEstructuras(res.data)
    })
        .catch((err) => {
            console.log("error", err);

        })
}
export const programacionMasivaPorEstrucutura = async (id_cliente, anio, semana, id_estructura, ruta) => {
    Swal.fire({
        title: 'Cargando...',
        text: 'Por favor espera',
        allowOutsideClick: false, // Evita que se cierre al hacer clic afuera
        didOpen: () => {
            Swal.showLoading(); // Muestra el spinner
        },
        customClass: {
            popup: 'custom-popup', // Añade una clase personalizada a la alerta
        }
    });
    const data = {
        id_cliente: id_cliente,
        anio: anio,
        semana: semana,
        id_estructura: id_estructura
    }
    await api.post(apiUrl + `/monitor/programacion/programacion-masiva`, data).then((res) => {
        Swal.close(); // Cierra el modal de carga
      
        
        // // Crea un Blob con el texto
        // const blob = new Blob([res.data], { type: 'text/plain' });

        // // Crea un enlace dinámico para descargar el archivo
        // const enlace = document.createElement('a');
        // enlace.href = URL.createObjectURL(blob);
        // enlace.download = `query id_estr. - ${id_estructura}.txt`; // Nombre del archivo descargado

        // // Dispara la descarga y elimina el enlace
        // enlace.click();
        // URL.revokeObjectURL(enlace.href);
    })
        .catch((err) => {
            Swal.close(); // Cierra el modal de carga
            console.log("error", err);

        })
}
